export default __webpack_public_path__ + "static/media/1253.d67ae19d.png";